import { baseSplitApi } from "../baseApi";


const path = "/rfq/end_client";
const calculate_price = path + "/calculate_cost"
const rfq = path + "/request_for_proposal"
const awardProjectPath = 'get_request_code'
const rfqApi = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        calculateEndClientRFQPrice: build.mutation({
            query: (data) => {
                return {
                    url: calculate_price,
                    method: 'POST',
                    body: data
                }
            },
        }),
        EndClientRFQ: build.mutation({
            query: (data) => {
                const { params, ...RFQData } = data;
                return {
                    url: rfq,
                    method: 'POST',
                    body: RFQData,
                    params: `type=${params}`
                }
            },
        }),
        getRequestCodeFromURL: build.query({
            query: ({ uuid, token = null, isClientOrSales = false }) => {
                return {
                    url: `${path}/get_request_code?uuid=${uuid}&token=${token}&isClientOrSales=${isClientOrSales}`
                }
            },
            providesTags : [awardProjectPath]
        }),
        awardEndClientProject: build.mutation({
            query: reqCode => {
                return {
                    url: `${path}/award_project?reqCode=${reqCode}`,
                    method: 'PUT'
                }
            },
            invalidatesTags : [awardProjectPath]
        })
    }),
    overrideExisting: false
})

export const { useCalculateEndClientRFQPriceMutation, useEndClientRFQMutation, useGetRequestCodeFromURLQuery, useAwardEndClientProjectMutation } = rfqApi;